import { Module } from './module.model';
import { BssLegacyProductDiscount } from './../../../../../common/data-access/api-client/src/lib/model/bssLegacyProductDiscount';
export class Plan {
  id!: number;
  articleNumber!: string;
  planType!: string;
  price!: number;
  originalPrice!: number;
  discount!: number;
  devicesCount!: number;
  workStationCount!: number;
  clientsCount!: number;
  modules!: Module[];
  additionalModules?: Module[];
  includedModules?: Module[];
  startDate!: Date;
  cloudVersion!: boolean;
  packageType!: string;
  monthlyCostSum?: number;
  subDisplayName?: string;
  legacyProductDiscount?: BssLegacyProductDiscount;

  static getStartOfContract(plan: Pick<Plan, 'startDate'>, isNewCustomer: boolean = false): Date {
    const startDate = new Date(plan.startDate) ?? new Date();
    const year = startDate.getFullYear();

    // new customers start next month
    const month = startDate.getMonth() + (isNewCustomer ? 1 : 0);
    // new customers start on first day of next month
    const day = isNewCustomer ? 1 : startDate.getDate();
    return new Date(year, month, day);
  }

  static getEndOfContract(plan: Pick<Plan, 'startDate'>, isNewCustomer: boolean = false): Date {
    const startOfContract = this.getStartOfContract(plan, isNewCustomer);
    return new Date(startOfContract.getFullYear() + 1, startOfContract.getMonth(), startOfContract.getDate());
  }

  static formatDateAsString(date: Date): string {
    const year = date.getFullYear();
    // Add 1 here only for display/formatting because getMonth()
    // returns a zero-based month number.
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}T00:00:00Z`;
  }
}
